
// assets/second-look.js — Second Look landing page: button spinners, duo "add both to bag", testimonial slider arrows.
(() => {
  if (window.wwmSecondLook) return;
  window.wwmSecondLook = true;

  // Same hand-off as the PDP Customizer: Stiletto's public 'apps:product-added-to-cart' event refreshes the
  // header cart count + quick cart contents, then clicking the cart icon opens the drawer.
  const cartAdded = () => {
    document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', { bubbles: true }));
    document.querySelector('[data-js-cart-icon]')?.click();
  };

  // Link buttons: small spinner on click (skipped for in-page #anchors)
  const initButton = (a) => a.addEventListener('click', () => {
    if (!(a.getAttribute('href') || '').startsWith('#')) a.classList.add('is-loading');
  });

  // Duo card: size select(s) -> live price -> add both pairs to cart in one request
  const initDuo = (card) => {
    const data = JSON.parse(card.querySelector('[data-duo-json]').textContent);
    const selects = [...card.querySelectorAll('[data-duo-size]')];
    const btn = card.querySelector('[data-duo-add]');
    const msg = card.querySelector('[data-duo-msg]');
    const price = card.querySelector('[data-duo-price]');
    const compare = card.querySelector('[data-duo-compare]');
    const fmt = (cents) => (cents / 100).toLocaleString(undefined, { style: 'currency', currency: data.currency });
    const picks = () => data.products.map((p, i) => p.sizes[(selects[i] || selects[0]).value]);

    selects.forEach((s) => s.addEventListener('change', () => {
      s.classList.remove('is-invalid');
      msg.textContent = '';
      const v = picks();
      if (v.some((x) => !x)) return;
      const sum = v[0].price + v[1].price;
      price.textContent = fmt(sum - Math.round(Math.min(v[0].price, v[1].price) * data.pct / 100));
      compare.textContent = fmt(sum);
    }));

    btn.addEventListener('click', async () => {
      const empty = selects.find((s) => !s.value);
      if (empty) { empty.classList.add('is-invalid'); empty.focus(); msg.textContent = data.sizeMsg; return; }
      btn.classList.add('is-loading');
      btn.disabled = true;
      const properties = { _source: 'Second Look LP', _second_look_duo: data.title };
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: picks().map((v) => ({ id: v.id, quantity: 1, properties })) })
        });
        const json = await res.json();
        if (!res.ok) throw new Error(json.description || json.message);
        cartAdded();
      } catch (e) {
        msg.textContent = e.message || data.errorMsg;
      }
      btn.classList.remove('is-loading');
      btn.disabled = false;
    });
  };

  // Slider arrows (hidden when everything fits)
  const initSlider = (el) => {
    const track = el.querySelector('[data-sl-track]');
    const [prev, next] = el.querySelectorAll('[data-sl-prev], [data-sl-next]');
    const step = () => track.firstElementChild.offsetWidth + parseFloat(getComputedStyle(track).columnGap || 0);
    const sync = () => {
      const max = track.scrollWidth - track.clientWidth;
      el.classList.toggle('is-static', max < 2);
      if (prev) prev.disabled = track.scrollLeft < 2;
      if (next) next.disabled = track.scrollLeft > max - 2;
    };
    prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', sync, { passive: true });
    new ResizeObserver(sync).observe(track);
    sync();
  };

  const init = (scope) => {
    const run = (sel, fn) => scope.querySelectorAll(sel).forEach((el) => {
      if (el.dataset.slReady) return;
      el.dataset.slReady = '1';
      fn(el);
    });
    run('.wwm-sl a.wwm-sl-btn', initButton);
    run('[data-wwm-sl-duo]', initDuo);
    run('[data-wwm-sl-slider]', initSlider);
  };

  window.addEventListener('pageshow', () => document.querySelectorAll('.wwm-sl-btn.is-loading').forEach((a) => a.classList.remove('is-loading')));
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => init(document)) : init(document);
})();
